/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ManagedUserTherapist } from './ManagedUserTherapist';
export type ManagedUser = {
    id: number;
    firstName: string;
    lastName: string;
    title: string | null;
    gender: ManagedUser.gender;
    email: string;
    image: string | null;
    isActive: boolean;
    therapists: Array<ManagedUserTherapist>;
};
export namespace ManagedUser {
    export enum gender {
        MALE = 'male',
        FEMALE = 'female',
        DIVERSE = 'diverse',
        NOT_SET = 'not_set',
        DELETED = 'deleted',
    }
}

